import { API, Auth } from '../../apis/limeAuthUtils/apiWrapper';
import { getCurrentAuthUserAlias, getCurrentAuthUserEmail } from '../../lib/utils';

export async function listAllBots() {
    /**
     * function to list all bot accounts
     */
    const apiName = 'v1/bot-management';
    const requester = await getCurrentAuthUserAlias();
    const myInit = {
        queryStringParameters: {
            requester: requester,
        },
    };
    return await API.get(apiName, '/v1/bot', myInit);
}

export async function listBotByName(username) {
    /**
     * function to list bot account by name
     */
    const apiName = 'v1/bot-management';
    const requester = await getCurrentAuthUserAlias();
    const myInit = {
        queryStringParameters: {
            requester: requester,
            username: username,
        },
    };
    return await API.get(apiName, '/v1/bot', myInit);
}

export async function onboardBot(username, password, description, ownerGroup, subscribedGroups) {
    /**
     * function to onboard bot account
     */
    const apiName = 'v1/bot-management';
    const requester = await getCurrentAuthUserAlias();
    const myInit = {
        body: {
            username: username,
            password: password,
            description: description,
            requester: requester,
            ownerGroup: ownerGroup,
            subscribedGroups: subscribedGroups,
        },
    };
    return await API.post(apiName, '/v1/bot', myInit);
}

export async function configureBot(username, description, ownerGroup, subscribedGroups) {
    /**
     * function to configure bot account
     */
    const apiName = 'v1/bot-management';
    const requester = await getCurrentAuthUserAlias();
    const myInit = {
        body: {
            username: username,
            description: description,
            requester: requester,
            ownerGroup: ownerGroup,
            subscribedGroups: subscribedGroups,
        },
    };
    return await API.put(apiName, '/v1/bot', myInit);
}

export async function offboardBot(username) {
    /**
     * function to offboard bot account
     */
    const apiName = 'v1/bot-management';
    const requester = await getCurrentAuthUserAlias();
    const myInit = {
        body: {
            username: username,
            requester: requester,
        },
    };
    return await API.del(apiName, '/v1/bot', myInit);
}

export async function fetchSubscribedGroups(region) {
    /**
     * function to fetch all subscribed groups by calling api
     */
    const authUserEmail = await getCurrentAuthUserEmail();
    const apiName = `${region}/v1/group-management`;
    const myInit = {
        queryStringParameters: {
            requester: authUserEmail,
            listOwned: false,
        },
    };
    return await API.get(apiName, '/v1/groups', myInit);
}
